import { Users, Trophy, Activity, Wrench, MonitorSmartphone, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const items = [
  {
    icon: Users,
    title: "Staff",
    desc: "Un equipo humano comprometido que acompaña al club en todas sus necesidades.",
  },
  {
    icon: Trophy,
    title: "Cuerpo técnico",
    desc: "Profesionales titulados y cualificados, preparados para competir al máximo nivel.",
  },
  {
    icon: Activity,
    title: "Preparador físico",
    desc: "La salud va primero. Invertimos en profesionales de máxima calidad.",
  },
  {
    icon: Wrench,
    title: "Equipo técnico",
    desc: "Material de entrenamiento de primer nivel para rendir y competir con seguridad.",
  },
  {
    icon: MonitorSmartphone,
    title: "Tecnología",
    desc: "Trabajamos como un club 100% digital, conectados con socios y jugadores.",
  },
];

export default function StaffGrid() {
  return (
    <section
      data-testid="staff-section"
      className="relative py-32 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#FFB800] mb-6 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FFB800]" />
              04 — Estructura
            </p>
            <h2 className="font-display text-4xl md:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] max-w-3xl">
              Cinco pilares.<br />
              <span className="italic font-light text-white/70">Un mismo objetivo.</span>
            </h2>
          </div>
          <p className="text-white/55 max-w-sm text-[15px]">
            Cada área del club trabaja para ofrecer la mejor experiencia
            deportiva, dentro y fuera del campo.
          </p>
          <Link
            to="/quienes-somos"
            data-testid="staff-quienes-somos-cta"
            className="btn-secondary self-start md:self-auto flex-shrink-0"
          >
            Conocé al equipo
            <ArrowUpRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                data-testid={`staff-card-${i}`}
                className="group relative bg-[#0A1121]/40 hover:bg-[#0A1121] border border-white/8 hover:border-[#FFB800]/40 rounded-[2rem] p-10 transition-all duration-500 flex flex-col gap-6 min-h-[280px]"
              >
                <div className="flex items-center justify-between">
                  <div className="h-12 w-12 rounded-full grid place-items-center border border-white/10 group-hover:border-[#FFB800] group-hover:text-[#FFB800] transition-colors">
                    <Icon size={20} strokeWidth={1.5} />
                  </div>
                  <span className="font-mono text-[10px] tracking-[0.3em] text-white/30">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-auto">
                  <h3 className="font-display text-2xl font-bold uppercase tracking-tight mb-3 group-hover:text-[#FFB800] transition-colors">
                    {it.title}
                  </h3>
                  <p className="text-white/55 text-[15px] leading-relaxed">
                    {it.desc}
                  </p>
                </div>
              </div>
            );
          })}
          {/* Closing card */}
          <div
            data-testid="staff-card-closing"
            className="relative bg-[#FFB800] text-[#030712] rounded-[2rem] p-10 flex flex-col justify-between min-h-[280px]"
          >
            <p className="font-mono text-[10px] tracking-[0.3em]">CDLB</p>
            <div>
              <h3 className="font-display text-3xl font-extrabold uppercase tracking-tight leading-[1]">
                Un club<br />100% digital.
              </h3>
              <p className="text-[#030712]/80 mt-4 text-[15px] leading-relaxed">
                Tradición y herramientas modernas trabajando juntas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
